
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.53786 4.12904C3.53786 3.62904 3.12952 3.2207 2.62952 3.2207C2.12952 3.2207 1.72119 3.62904 1.72119 4.12904V4.20404C1.72119 4.70404 2.12952 5.11237 2.62952 5.11237C3.12952 5.11237 3.53786 4.70404 3.53786 4.20404V4.12904ZM3.53786 9.99146C3.53786 9.49146 3.12952 9.08313 2.62952 9.08313C2.12952 9.08313 1.72119 9.49146 1.72119 9.99146V10.0665C1.72119 10.5665 2.12952 10.9748 2.62952 10.9748C3.12952 10.9748 3.53786 10.5665 3.53786 10.0665V9.99146ZM6.03785 9.16654C5.57761 9.16654 5.20452 9.53964 5.20452 9.99988C5.20452 10.4601 5.57761 10.8332 6.03785 10.8332H17.4453C17.9056 10.8332 18.2787 10.4601 18.2787 9.99988C18.2787 9.53964 17.9056 9.16654 17.4453 9.16654H6.03785ZM2.62952 14.8874C3.12952 14.8874 3.53786 15.2957 3.53786 15.7957V15.8707C3.53786 16.3707 3.12952 16.779 2.62952 16.779C2.12952 16.779 1.72119 16.3707 1.72119 15.8707V15.7957C1.72119 15.2957 2.12952 14.8874 2.62952 14.8874ZM5.20452 4.16654C5.20452 3.70631 5.57761 3.33321 6.03785 3.33321H17.4453C17.9056 3.33321 18.2787 3.70631 18.2787 4.16654C18.2787 4.62678 17.9056 4.99988 17.4453 4.99988H6.03785C5.57761 4.99988 5.20452 4.62678 5.20452 4.16654ZM6.03785 14.9999C5.57761 14.9999 5.20452 15.373 5.20452 15.8332C5.20452 16.2934 5.57761 16.6665 6.03785 16.6665H17.4453C17.9056 16.6665 18.2787 16.2934 18.2787 15.8332C18.2787 15.373 17.9056 14.9999 17.4453 14.9999H6.03785Z","fill":"#16171F"}})])
          )
        }
      }
    